import React, { useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '@i18n/client';
import { locales, defaultLocale } from '@i18n/index';

export const LocaleRouteWrapper: React.FC = () => {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isValidLocale =
    locale && locales.includes(locale as (typeof locales)[number]);

  useEffect(() => {
    if (!isValidLocale) {
      const pathWithoutLocale = location.pathname.replace(/^\/[^/]+/, '');
      navigate(`/${defaultLocale}${pathWithoutLocale}${location.search}`, {
        replace: true,
      });
      return;
    }

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, isValidLocale, i18n, navigate, location]);

  if (!isValidLocale) return null;

  return <Outlet />;
};
